import React, { Suspense } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { Sheet, SheetContent } from 'src/components/ui/sheet';
import LoadingState from 'src/components/admin/LoadingState';
import AdminNavbar from './AdminNavbar';
import AdminSidebar, { NAV_ITEMS } from './AdminSidebar';

const Dashboard = React.lazy(() => import('src/pages/Dashboard'));
const Salons = React.lazy(() => import('src/pages/Salons'));
const Appointements = React.lazy(() => import('src/pages/Appointements'));
const Kpis = React.lazy(() => import('src/pages/Kpis/Kpis'));
const Specialties = React.lazy(() => import('src/pages/Specialties/Specialties'));
const Services = React.lazy(() => import('src/pages/Services/Services'));
const SubServices = React.lazy(() => import('src/pages/SubServices/SubServices'));
const OurPix = React.lazy(() => import('src/pages/Our-pix/OurPix'));
const Ads = React.lazy(() => import('src/pages/ads/ad'));
const WishListPartner = React.lazy(() => import('src/pages/WishListPartner/WishListPartner'));
const GiftCard = React.lazy(() => import('src/pages/GiftCard/GiftCard'));
const Commission = React.lazy(() => import('src/pages/Commission/Commission'));
const NotFound = React.lazy(() => import('src/pages/NotFound'));

const SIDEBAR_KEY = 'izya_admin_sidebar_collapsed';

export default function AdminLayout() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(
    () => localStorage.getItem(SIDEBAR_KEY) === 'true'
  );

  const title =
    NAV_ITEMS.find((item) => location.pathname.startsWith(item.href))?.title ||
    'Administration IZYA';

  const toggleCollapsed = () => {
    setCollapsed((value) => {
      const next = !value;
      localStorage.setItem(SIDEBAR_KEY, String(next));
      return next;
    });
  };

  return (
    <div className="flex h-full min-h-screen bg-background">
      <div className="hidden lg:block">
        <div className={collapsed ? 'h-screen w-[72px]' : 'h-screen w-64'}>
          <AdminSidebar
            collapsed={collapsed}
            onToggle={toggleCollapsed}
            className="fixed inset-y-0 left-0"
          />
        </div>
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-72 p-0">
          <AdminSidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex min-w-0 flex-1 flex-col">
        <AdminNavbar onMenuClick={() => setMobileOpen(true)} title={title} />
        {/* Padding lives on the inner wrapper: <main> is the scroll container,
            and sticky table headers pin to its edge only without padding. */}
        <main className="flex-1 overflow-auto">
          <div className="p-4 md:p-6">
          <Suspense fallback={<LoadingState rows={8} />}>
            <Switch>
              <Route exact path="/app" render={() => <Redirect to="/app/dashboard" />} />
              <Route path="/app/dashboard" component={Dashboard} />
              <Route path="/app/kpi" component={Kpis} />
              <Route path="/app/our-pix" component={OurPix} />
              <Route path="/app/appointements" component={Appointements} />
              <Route path="/app/salons" component={Salons} />
              <Route path="/app/specialties" component={Specialties} />
              <Route path="/app/services" component={Services} />
              <Route path="/app/prestation" component={SubServices} />
              <Route path="/app/ads" component={Ads} />
              <Route path="/app/wishlist-partner" component={WishListPartner} />
              <Route path="/app/gift-card" component={GiftCard} />
              <Route path="/app/commission/:salonId?" component={Commission} />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}
